import { createAction, props } from '@ngrx/store';

export const setCart = createAction(
    '[Cart] setCart',
    props<{ info: any }>()
);
export const unSetCart = createAction('[Cart] unSetCart');

export const getCart = createAction('[Cart] getCart');
